/* v21 S4 tier 2 -- moved from snippets/cart-drawer.liquid (was inline). BYOB bundle guard: removes the hamper when the bundle is incomplete or added outside the builder. Renders on every page via the drawer. */
  /* BYOB bundle guard: remove hamper if bundle is incomplete or added without builder */
  (function() {
    var guardRunning = false;

    function checkByobBundle(cartData) {
      if (guardRunning) return;
      var items = cartData ? cartData.items : null;
      if (!items || items.length === 0) return;

      var byobItems = [];
      var orphanHampers = [];

      items.forEach(function(item) {
        var hasProp = item.properties && item.properties._byob_bundle === 'shark-tank-hamper';
        var isHamper = item.title && item.title.toLowerCase().includes('shark tank hamper');
        if (hasProp) byobItems.push(item);
        if (isHamper && !hasProp) orphanHampers.push(item);
      });

      /* No BYOB-related items at all — skip entirely */
      if (byobItems.length === 0 && orphanHampers.length === 0) return;

      /* Valid: complete bundle (5+ items) with no orphans */
      if (orphanHampers.length === 0 && byobItems.length >= 5) return;

      var updates = {};
      orphanHampers.forEach(function(item) { updates[item.key] = 0; });
      if (byobItems.length > 0 && byobItems.length < 5) {
        byobItems.forEach(function(item) { updates[item.key] = 0; });
      }
      if (Object.keys(updates).length === 0) return;

      guardRunning = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function() {
        guardRunning = false;
        window.location.reload();
      }).catch(function() {
        guardRunning = false;
      });
    }

    /* Wait for Dawn's pub/sub to be available, then subscribe */
    function initGuard() {
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
          if (event.cartData) checkByobBundle(event.cartData);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGuard);
    } else {
      initGuard();
    }
  })();
